import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import OneColumnB from '../components/OneColumnB/OneColumnB'

const Coaching = () => {
  return (
    <div>
      <Navbar />
      <div className="app__background">
        <div className="app__content">
          <h1 className="headtext__roboto">Coaching</h1>
        </div>
        <div className="section__padding">
          <OneColumnB
            subtitle="Role & Responibilities"
            paragraph="All coaching roles are voluntary. We encourage all adults who's child is involved in either capacity, recreation or competitive to assist in the development of their child as well as others. Both recreation and competitive coaches will be given support to help develop players at both levels."
          />
        </div>
        <div className="section__padding">
        <OneColumnB
          subtitle="Coaching Certifications"
        />
        <p className="p__opensans">We encourage all competitive coaches to explore getting their coaching license. </p>
        <p className="p__opensans">There are two avenues to choose from, both a are great starting points!</p>
        <a style={{color: 'red'}} className="p__opensans" href="https://learning.ussoccer.com/coach/courses/available/19/list" target="_blank" rel="noreferrer">United States Soccer Federation (USSF) </a>
        <a style={{color: 'yellow'}} className="p__opensans" href="https://portal.unitedsoccercoaches.org/s/lt-event?id=a1U3u0000026VfwEAE&site=a0d6A000001GUuxQAG" target="_blank" rel="noreferrer"> United Soccer Coaches(USC)</a>

        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  )
}

export default Coaching